export default {"src":"/login-app/[GIT_HASH]/_next/static/media/campaign.9c251430.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};